<template>
  <div>
    <el-card>
      <el-input
        style="width:100%"
        size="small"
        clearable
        placeholder="输入内容进行搜索"
        v-model="filterText"
        :disabled="treeData.length == 0"
      >
      </el-input>
      <el-tree
        style="margin-top:5px"
        v-loading="treeLoading"
        :data="data"
        show-checkbox
        node-key="thisId"
        ref="tree"
        highlight-current
        :props="defaultProps"
        @check-change="clickTree"
        :filter-node-method="filterNode"
      >
      </el-tree>
      <el-collapse @change="handleChange" v-model="activeName">
        <el-collapse-item title="已选择列表" :name="1">
          <div class="collapse-item">
            {{ nameList.toString() || "暂无数据" }}
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>
  </div>
</template>
<script>
export default {
  name: "SelectTree",
  props: {
    treeData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isShow: {
      type: Boolean,
      default: () => {}
    }
  },
  data() {
    return {
      data: this.treeData,
      filterText: "",
      treeLoading: false,
      defaultProps: {
        children: "children",
        label: "label"
      },
      treeValue: [],
      nameList: [],
      activeName: 1
    };
  },
  created() {
    this.filterText = "";
  },
  mounted() {},

  methods: {
    handleChange() {
      let data = this.$refs.tree.getCheckedNodes();
      let datas = data.map((item) => {
        if (item.thisLevel == 2) {
          let obj = {
            name: item.label,
            id: item.thisId
          };
          return obj;
        } else {
          return "";
        }
      });
      datas = datas.filter((item) => {
        return item != "";
      });
      this.nameList = datas.map((item) => {
        return item.name;
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    clickTree(val) {
      let data = this.$refs.tree.getCheckedNodes();
      let ids = data.map((item) => {
        if (item.thisLevel == 2) {
          return item.thisId;
        } else {
          return "";
        }
      });
      let datas = data.map((item) => {
        if (item.thisLevel == 2) {
          let obj = {
            name: item.label,
            id: item.thisId
          };
          return obj;
        } else {
          return "";
        }
      });
      ids = ids.filter((item) => {
        return item != "";
      });
      datas = datas.filter((item) => {
        return item != "";
      });
      this.treeValue = ids || [];
      this.$emit("changeIds", ids);
      this.$emit("changeDatas", datas);
      this.nameList = datas.map((item) => {
        return item.name;
      });
    }
  },
  watch: {
    treeData: function(nval) {
      if (nval.length > 0) {
        this.data = nval;
        this.$nextTick(() =>{
          this.handleChange()
        })
      }
    },
    filterText: function(val) {
      this.$refs.tree.filter(val);
    },
    isShow: function(val) {
      if (!val) {
        this.filterText = "";
      }
    }
  }
};
</script>
<style scoped lang="scss">
.el-tree {
  width: 100%;
  display: inline-block;
  overflow-y: auto;
  overflow-x: scroll;
  overflow: auto;
  max-height: 180px;
}
.collapse-item {
  width: 100%;
  max-height: 80px;
  word-wrap: break-word;
  overflow-y: scroll;
}
</style>
